var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-file-input',{attrs:{"loading":_vm.loading,"disabled":_vm.disabled,"accept":".mp4","label":"direct upload .mp4 to Vimeo"},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}})}
var staticRenderFns = []

export { render, staticRenderFns }